import React, { FC } from "react";

import Select from "../../../../../components/elements/Select";
import classes from "../../CampaignsDashboard.module.scss";
import { CampaignType } from "../../../../../types/campaignTypes";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";

type CampaignsSelectorProps = {
  selectedCampaign: CampaignType;
  options: SelectOptionType[];
  handleChangeSelectedCampaign: (e: any) => void;
};

const CampaignsSelector: FC<CampaignsSelectorProps> = ({ selectedCampaign, options, handleChangeSelectedCampaign }) => {
  return (
    <Select
      className={classes.selector}
      label="Campaigns"
      options={options}
      value={selectedCampaign.brandgenCampaignId}
      onChange={handleChangeSelectedCampaign}
    />
  );
};

export default CampaignsSelector;
